export const AI_PROMPTS_CONVERSATION = [
  { prompt: "Create an account action plan", text: "Create an account action plan", id: 1 },
  { prompt: "How to upsell/cross sell", text: "How to upsell/cross sell", id: 2 },
  { prompt: "Give me a pitch pack", text: "Give me a pitch pack", id: 3 },
  { prompt: "Prep me for a meeting", text: "Prep me for a meeting", id: 4 },
  { prompt: "Spontaneous pitch responses", text: "Spontaneous pitch responses", id: 5 },
  { prompt: "Update my CRM", text: "Update my CRM", id: 6 },
];

export const messageStyleOptions = [
  {
    key: "trigger_led",
    title: "Trigger-based",
    description: "Personalized outreach built around recent events, signals, or buying triggers.",
  },
  {
    key: "pain_based",
    title: "Pain-based",
    description: "Problem-focused messaging that highlights challenges and positions your solution clearly.",
  },
  {
    key: "ultrashort",
    title: "Ultrashort",
    description: "Concise, high-conversion messages optimized for quick reads and fast replies.",
  },
];

/** Campaign wizard — up to 3 messaging styles (sequence step advance settings use messageStyleOptions). */
export const CAMPAIGN_MESSAGE_STYLE_OPTIONS = [
  {
    key: "purpose_driven_pitch",
    title: "Purpose Driven Pitch (Recommended)",
    description: "Purpose → Use Cases → Proof → CTA",
  },
  {
    key: "adaptive_personalisation",
    title: "Adaptive Personalisation",
    description: "Signal → Selected Solution → Proof → CTA",
  },
  {
    key: "pain_point_trigger",
    title: "Pain Point Trigger",
    description: "Pain → Cost of Inaction → Solution",
  },
  {
    key: "news_signal",
    title: "News Signal",
    description: "Trigger Event → Implication → Question",
  },
  {
    key: "industry_use_case",
    title: "Industry Use Case",
    description: "Industry Trend → Use Case → Outcome",
  },
  {
    key: "case_study",
    title: "Case Study",
    description: "Similar Customer → Result → Applicability",
  },
  {
    key: "competitive_intelligence",
    title: "Competitive Intelligence",
    description: "Competitor Move → Risk → Opportunity",
  },
  {
    key: "consultative_discovery",
    title: "Consultative Discovery",
    description: "Insight → Question → Discussion",
  },
  {
    key: "ultra_short_direct",
    title: "Ultra Short Direct",
    description: "Value Prop → CTA",
  },
  
];

export const MAX_CAMPAIGN_MESSAGE_STYLES = 1;

export const lengthOptions = [
  {
    key: "10-30",
    title: "Ultra-Short (1–3 lines)",
    description: "Best for WhatsApp, SMS, Social DMs",
  },
  {
    key: "50-90",
    title: "Short (50–90 words)",
    description: "Quick, punchy outreach",
  },
  {
    key: "90-150",
    title: "Standard (90–150 words)",
    description: "Balanced detail for emails & LinkedIn",
  },
  {
    key: "150-250",
    title: "Detailed (150–250 words)",
    description: "Ideal for follow-ups or elaborated value propositions",
  },
  {
    key: "250+",
    title: "Extended (250+ words)",
    description: "For narrative emails, case study intros, or formal proposals",
  },
];

export const AI_PROMPTS_COMPANY_LEVEL = [
  { id: 0, prompt: "I want to train you on my campaigns.", text: "I want to train you on my campaigns." },
  { id: 1, prompt: "I want to train you on my accounts", text: "I want to train you on my accounts." },
  { id: 2, prompt: "I want to onboard the company's brand voice.", text: "I want to onboard the company's brand voice." },
  { id: 3, prompt: "I want to define the company elevator pitch.", text: "I want to define the company elevator pitch." },
  { id: 4, prompt: "I want to identify the competitive differentiators.", text: "I want to identify the competitive differentiators." },
  { id: 5, prompt: "I want to define the Ideal Customer Profile (ICP).", text: "I want to define the Ideal Customer Profile (ICP)." },
  { id: 6, prompt: "I want to collect social proof for outbound messaging.", text: "I want to collect social proof for outbound messaging." },
  { id: 7, prompt: "I want to identify outreach assets.", text: "I want to identify outreach assets." },
  { id: 8, prompt: "I want to define restricted messaging rules.", text: "I want to define restricted messaging rules." },
  { id: 9, prompt: "I want to define compliance and outreach constraints.", text: "I want to define compliance and outreach constraints." },
  { id: 10, prompt: "I want to build the ideal cold email template", text: "I want to build the ideal cold email template." },
];
